import { useFonts, Italiana_400Regular } from '@expo-google-fonts/italiana';
import { JetBrainsMono_400Regular } from '@expo-google-fonts/jetbrains-mono';
import { JockeyOne_400Regular } from '@expo-google-fonts/jockey-one';
import { Lato_400Regular } from '@expo-google-fonts/lato';
import { StatusBar } from 'expo-status-bar';
import { initializeApp } from 'firebase/app';
import { initializeFirestore } from 'firebase/firestore';
import { SafeAreaProvider } from 'react-native-safe-area-context';

import { FloorProvider } from './src/context/FloorContext';
import { GameProvider } from './src/context/GameContext';
import Home from './src/pages/Home';

export default function App() {
  const firebaseConfig = {
    apiKey: 'AIzaSyChty-HELzgi3y7VmRg5XAUV0bq_iYkgew',
    authDomain: 'casa-de-metal-game.firebaseapp.com',
    projectId: 'casa-de-metal-game',
    storageBucket: 'casa-de-metal-game.appspot.com',
    messagingSenderId: '985888971134',
    appId: '1:985888971134:web:d3c0edb4782db0c5787b2f',
    measurementId: 'G-RDXC1Q0P15',
  };

  const app = initializeApp(firebaseConfig);
  initializeFirestore(app, { experimentalAutoDetectLongPolling: true });

  const [fontsLoaded] = useFonts({
    Italiana: Italiana_400Regular,
    Lato: Lato_400Regular,
    JetBrainsMono: JetBrainsMono_400Regular,
    JockeyOne: JockeyOne_400Regular,
  });

  if (!fontsLoaded) {
    return null;
  }

  return (
    <SafeAreaProvider>
      <FloorProvider>
        <GameProvider>
          <StatusBar style="dark" backgroundColor="transparent" />
          <Home />
        </GameProvider>
      </FloorProvider>
    </SafeAreaProvider>
  );
}
